module.exports = __webpack_public_path__ + "img/event-ic-btn-03.ef4dd17f.png";